let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6W2BP"), load("3pwml")]).then(() => parcelRequire('jFrSc'));